import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const FaqAccordion = ({ items }) => {
    const [open, setOpen] = useState(0);
    return (
        <div className="divide-y divide-border border border-border bg-card" data-testid="faq-accordion">
            {items.map((item, i) => (
                <div key={i} data-testid={`faq-item-${i}`}>
                    <button
                        onClick={() => setOpen(open === i ? -1 : i)}
                        className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-muted/50 transition-colors"
                        data-testid={`faq-toggle-${i}`}
                    >
                        <span className="font-heading font-semibold text-base sm:text-lg">{item.q}</span>
                        <span className="shrink-0 text-primary">{open === i ? <Minus size={20} /> : <Plus size={20} />}</span>
                    </button>
                    {open === i && (
                        <div className="px-6 pb-6 -mt-1 text-muted-foreground leading-relaxed text-sm sm:text-base" data-testid={`faq-answer-${i}`}>
                            {item.a}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
